import api from '../services/api';

const CafeVerdePublicModel = {
    // Obtener todas las variedades de café verde disponibles
    getAll: async () => {
        try {
            const response = await api.get('/cafe-verde');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo café verde:', error);
            return [];
        }
    },

    // Obtener variedades disponibles (en stock)
    getDisponibles: async () => {
        try {
            const response = await api.get('/cafe-verde?disponible=true');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo café verde disponible:', error);
            return [];
        }
    }
};

export default CafeVerdePublicModel;